import { WorkflowItemCode } from '../../constants';
import { TaskItemStatus } from '../constants';
import { Task, TaskItem } from '../interfaces';

export const getNextNotStartedOrInProgressItem = (currentTask: Task, currentItemIndex = 0): TaskItem | undefined => {
  return currentTask.items.every((item) => item.code !== WorkflowItemCode.EXPASSES)
    ? currentTask.items[currentItemIndex + 1]
    : currentTask.items.find(
        (item, index) =>
          (!item.status || item.status === TaskItemStatus.NOT_STARTED || item.status === TaskItemStatus.IN_PROGRESS) &&
          index > currentItemIndex,
      );
};
